export const changeLocation = (newLocation: string): void => {
  window.location.assign(newLocation);
};

export const getURLStateValue = (): string | null => {
  const query = new URLSearchParams(window.location.search);
  return query.get('state');
};
